import { ActionTypes } from "../type";

const initialState = {
  new_registration: null,
};

export const newRegistrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SUBMIT_NEW_REGISTRATION:
      return { ...state, new_registration: action.payload };
   case ActionTypes.ClEAR_NEW_REGISTRATION:
        return { ...state, new_registration: null};
    default:
      return state;
  }
};
